/**
 * Tokeny warstwy dokumentowej druku — JEDYNE miejsce w pakiecie z literalnymi
 * hexami kolorów (pilnuje tego test niezmienników, dokładnie jak w poczcie).
 *
 * DLACZEGO PALETA JEST MONOCHROMATYCZNA. Dokumenty A4/A5 wychodzą z drukarek
 * laserowych — w praktyce mono — a etykiety termiczne fizycznie nie znają
 * koloru. Kolor na wydruku to obietnica, której papier nie dotrzyma, więc
 * tokeny mówią wyłącznie skalą szarości. STRUKTURA za to jest tą samą
 * strukturą, co `email-templates/src/tokens.ts` (paleta + kroje + skale
 * odstępów): gdy kiedyś dojdzie druk kolorowy (broszury?), wystarczy dołożyć
 * wartości, nie przebudowywać wzorów. Wartości szarości wyprowadzone z trybu
 * Paper Aurory (`packages/ui/src/styles/aurora.css`), żeby facsimile
 * w panelu wyglądało jak reszta aplikacji.
 */

export interface PrintPalette {
  /** Tło strony — na papierze zawsze „brak tuszu". */
  paper: string;
  /** Wgłębienie: pasek nagłówka tabeli, stopka. */
  paperSubtle: string;
  /** Tusz podstawowy. */
  ink: string;
  /** Tusz drugorzędny (opisy, etykiety pól). */
  inkMuted: string;
  /** Linie siatek i ramek. */
  border: string;
  /** Ramka mocna (obrys etykiety, kreska podpisu). */
  borderStrong: string;
}

/** Jedyna paleta v1 — mono. */
export const MONO: PrintPalette = {
  paper: '#FFFFFF', // --paper-0
  paperSubtle: '#F1F5F9', // --paper-100
  ink: '#111827', // najciemniejszy tusz — pełne krycie na laserze
  inkMuted: '#64748B', // --paper-500
  border: '#CBD5E1', // --paper-300
  borderStrong: '#0F172A', // --paper-900
};

/**
 * Kroje. Chromium w obrazie print-core ma fonty z polskimi glifami
 * (PR-2b instaluje je w Dockerfile) — stos z pełnym fallbackiem systemowym,
 * jak w poczcie: kto ma Inter, widzi Aurorę, reszta dostaje metrycznie
 * zbliżony krój systemowy, a nie Times New Roman.
 */
export const FONT = {
  ui: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  mono: "'JetBrains Mono', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
  /**
   * Krój szeryfowy dla dokumentów tenanta (protokół, certyfikat, umowa).
   * Stos kończy się rodziną ogólną `serif`, więc rozwiązuje się na KAŻDYM
   * systemie — także wtedy, gdy obraz print-core nie ma akurat Source Serif.
   */
  serif: "'Source Serif 4', Georgia, 'Times New Roman', 'Liberation Serif', serif",
} as const;

/** Skala odstępów w mm (druk mówi milimetrami, nie pikselami). */
export const SPACE_MM = {
  s1: 1,
  s2: 2,
  s3: 3,
  s4: 4,
  s6: 6,
  s8: 8,
  s10: 10,
} as const;

/** Marginesy stron dokumentów w mm. */
export const MARGIN_MM = {
  A4: 12,
  A5: 10,
  receipt80mm: 4,
} as const;
